import { Api } from "../../../services/Api";

export const CHECKOUT_URL = "/shop/checkout";

// Posting to the checkout URL (rather than /actions/...) keeps request-path
// hooks such as IceBrickService::handleFrontEnd firing the same way they do
// for the legacy checkout forms.
//
// Always sent as form data, like the legacy forms: Craft ignores an `action`
// param in a JSON body (Request::checkIfActionRequest), so a JSON post would
// just render the page.
export function updateCart(data) {
    const form = data instanceof FormData ? data : toFormData(data);
    form.set("action", "commerce/cart/update-cart");

    return Api.post(CHECKOUT_URL, form);
}

// Nested objects become bracketed keys (`fields[orderGiftMessage]`). `null`
// clears a value (e.g. paymentSourceId), which Commerce expects as "".
function toFormData(data, form = new FormData(), prefix = "") {
    Object.entries(data).forEach(([key, value]) => {
        const name = prefix ? `${prefix}[${key}]` : key;

        if (value !== null && typeof value === "object") {
            toFormData(value, form, name);
        } else {
            form.append(name, value ?? "");
        }
    });
    return form;
}

export function firstError(error, key) {
    const errors = error?.response?.data?.errors ?? {};
    const value = errors[key];

    if (Array.isArray(value) && value.length) {
        return value[0];
    }

    return (
        error?.response?.data?.message ??
        "Something went wrong. Please try again."
    );
}
